/**
 * Has an invite actually left this device? (card E5sHUI8IkN6b, Jonathan email
 * 2026-10-16: "in onboarding if user already invited partner should be
 * prompted with another intro action").
 *
 * The pair code is issued the moment the invite card renders, so "a code
 * exists" says nothing about whether the person did anything with it. What
 * counts as inviting is the three ways the invite leaves the app — Copy,
 * Share, Email the 24-hour link — and each of those calls markInviteSent()
 * on success. The flag is localStorage, same shape and same lifetime as
 * FIRST_ACT_KEY: per device, never synced, and it exists only to stop the
 * first-act card offering "Invite your partner" to somebody who already sent
 * one.
 */
export const INVITE_SENT_KEY = 'pear.invite-sent';

/** In-page signal: the flag just flipped, so the first-act card can re-read it
 *  without waiting for the next load. */
export const INVITE_SENT_EVENT = 'pear:invite-sent';

/** Read: has an invite left this device? Storage unavailable → false. */
export function hasSentInvite(): boolean {
  try {
    return localStorage.getItem(INVITE_SENT_KEY) === '1';
  } catch {
    return false;
  }
}

/** Write: an invite left the device. Private mode must not throw. */
export function markInviteSent(): void {
  try {
    localStorage.setItem(INVITE_SENT_KEY, '1');
  } catch {
    /* private mode — the card will offer the invite again, which is safe */
  }
  try {
    window.dispatchEvent(new Event(INVITE_SENT_EVENT));
  } catch {
    /* no window (SSR/test) — the flag is still on disk for the next read */
  }
}
